import React from "react";
import { bool, node, object, objectOf, string } from "prop-types";

import SentryErrorBoundary from "src/shared/components/SentryErrorBoundary";
import getDisplayName from "src/shared/utilities/getDisplayName";

import FormErrorCaught from "../FormErrorCaught";

const SentryErrorBoundaryLog = ({
  children,
  componentProps,
  isModal,
  tags
}) => {
  const onErrorRender = () => <FormErrorCaught isModal={isModal} />;

  return (
    <SentryErrorBoundary
      componentProps={componentProps}
      onErrorRender={onErrorRender}
      tags={tags}
    >
      {children}
    </SentryErrorBoundary>
  );
};

SentryErrorBoundaryLog.propTypes = {
  children: node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: object.isRequired,
  isModal: bool,
  tags: objectOf(string)
};

SentryErrorBoundaryLog.defaultProps = {
  isModal: false,
  tags: null
};

export const withSentryErrorBoundary = (Component, { tags = {} } = {}) => {
  const WithSentryErrorBoundary = props => (
    /* eslint-disable react/prop-types */
    <SentryErrorBoundaryLog
      componentProps={props}
      isModal={props.isModal}
      tags={{
        contact_box: "experts",
        feature: "experts-contact-box",
        ...tags
      }}
    >
      <Component {...props} />
    </SentryErrorBoundaryLog>
    /* eslint-enable react/prop-types */
  );
  const componentName = getDisplayName(Component);

  WithSentryErrorBoundary.displayName = `${componentName}WithSentryErrorBoundary`;

  return WithSentryErrorBoundary;
};
